import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectBillingOverview } from './useClientBilling.utils';
import { useClientInvoices } from './useClientInvoices';
const EMPTY_SELECTION = {
    upcomingInvoice: null,
    latestInvoice: null,
    overdueInvoices: []
};
export function useClientBilling(customerId) {
    var _futureQuery_data;
    const { api } = useStoreActions();
    const { invoices, isLoading: isInvoicesLoading } = useClientInvoices(customerId);
    const futureQuery = useQueryState({
        queryKey: [
            QueryKeys.ClientFutureInvoices,
            customerId
        ],
        queryFn: ()=>api.reports.getFutureInvoicesByCustomer(customerId),
        enabled: customerId != null
    });
    if (customerId == null) {
        return {
            billing: EMPTY_SELECTION,
            isLoading: false
        };
    }
    if (isInvoicesLoading || futureQuery.isLoading) {
        return {
            billing: EMPTY_SELECTION,
            isLoading: true
        };
    }
    const futures = (_futureQuery_data = futureQuery.data) !== null && _futureQuery_data !== void 0 ? _futureQuery_data : [];
    return {
        billing: selectBillingOverview(invoices, futures),
        isLoading: false
    };
}
